import { useEffect, useState } from "react";
import { SUBJECT, SUBJECTS_BY_CLASS } from "../../../Api/Api";
import { Axios } from "../../../Api/axios";
import { Link } from "react-router-dom";
import TableShow from "../../../Components/Dashboard/Table";

export default function T_Ads() {
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedGradeId, setSelectedGradeId] = useState("1");

  useEffect(() => {
    setLoading(true);
    Axios.get(`${SUBJECTS_BY_CLASS(selectedGradeId)}?limit=${limit}&page=${page}`)
      .then((data) => {
        setCategories(data.data.subjects || []);
        setTotal(data.data.subjects_count || 0);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [limit, page, selectedGradeId]);

  const header = [
    { key: "name", name: "Title" },
    { key: "teacher_photo", name: "Image" },
    { key: "created_at", name: "Created" },
    { key: "updated_at", name: "Updated" },
  ];

  async function handleDelete(id) {
    try {
      await Axios.delete(`${SUBJECT}/${id}`);
      setCategories((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="white w-100 px-4 py-3 rounded shadow-sm">
      <div className="d-flex align-items-center justify-content-between">
        <h1>Ads Page</h1>
        <Link className="btn btn-primary" to="/dashboard/Ad/add">
          Add Ad
        </Link>
      </div>

      <TableShow
        limit={limit}
        setLimit={setLimit}
        page={page}
        header={header}
        data={categories}
        delete={handleDelete}
        setPage={setPage}
        loading={loading}
        total={total}
        search="title"
        searchLink={SUBJECT}
        selectedGradeId={selectedGradeId}
        setSelectedGradeId={setSelectedGradeId}
      />
    </div>
  );
}
